import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { RealPhoto } from "./PhotoSlot";

const ARROWS = [
  "We understand how devices are concealed, because concealment is an engineering problem we work on",
  "We understand their power and transmission behaviour, because we design to it",
  "We track what is being deployed now, not what was deployed a decade ago",
];

export default function About() {
  return (
    <section id="why-lat" className="border-t border-hairline py-12 sm:py-16" data-testid="about-section">
      <div className="grid site-x grid-cols-1 items-start gap-12 lg:grid-cols-2">
        <Reveal>
          <Eyebrow>Why us</Eyebrow>
          <h3 className="mt-4 font-head font-extrabold leading-tight tracking-tight h-sec">
            The same engineering, applied in reverse.
          </h3>
          <p className="mt-5 text-base leading-relaxed text-sub">
            Law Abiding Technology has designed and manufactured surveillance
            and security technology for India&rsquo;s defence, law enforcement
            and government agencies since 2005. TSCM Services is the
            counter-surveillance arm of that same company.
          </p>
          <p className="mt-4 text-base leading-relaxed text-sub">
            It means our teams approach a room from the engineering side. They
            understand how covert devices draw power, how they are concealed
            inside ordinary fittings, how they transmit, and what they are
            designed to do to avoid detection, because that engineering is
            the company&rsquo;s daily work.
          </p>
          <ul className="mt-7 flex flex-col gap-3.5" data-testid="about-points-list">
            {ARROWS.map((point) => (
              <li key={point} className="flex items-start gap-3 text-base leading-relaxed text-ink">
                <ArrowRight size={15} className="mt-1.5 shrink-0 text-violet" />
                <span>{point}</span>
              </li>
            ))}
          </ul>
          <p className="mt-8 border-t border-hairline pt-5 text-sm uppercase leading-relaxed tracking-[0.16em] text-sub">
            Law Abiding Technology is an ISO 9001:2015 certified company,
            founded in 2005.
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <RealPhoto
            src="/media/residence-lounge-sweep.jpg"
            alt="A full sweep in progress at a residence — antenna mast, kit cases and live spectrum analysis on a laptop"
            caption="A residential inspection in progress"
            testid="about-image"
          />
        </Reveal>
      </div>
    </section>
  );
}
